import React, { useContext, useState } from "react";
import { DataContext } from "../../../contexts/DataContext";
import styled from "styled-components";
import moment from "moment";

import Modal from "../../UI/Modal/Modal";
import Panel from "../../UI/Panel/Panel";
import PanelContent from "../../UI/Panel/PanelContent";
import PanelTitle from "../../UI/Panel/PanelTitle";
import Progress from "../../UI/Progress/Progress";
import StageContent from "../../UI/Progress/StageContent";
import KickOff from "./KickOff";
import Select from "react-select";
import TeamSelect from "./TeamSelect";
import { UIContext } from "../../../contexts/UIContext";
import VenueSelect from "./VenueSelect";
import CompetitionSelect from "./CompetitionSelect";
import { useEffect } from "react";

const SelectContainer = styled(Select)`
  min-width: 200px;
  margin: 0.5em;
  width: ${(props) => (props.setSize ? "128px" : "")};
`;

export default function CreateFixture({
  show,
  onCancel,
  onSaved,
  edit = false,
  fixture,
}) {
  const { createFixture, editFixture } = useContext(DataContext);
  const [date, setDate] = useState(moment());
  const [time, setTime] = useState(moment("15:00", "HH:mm"));
  const [homeFighter, setHomeFighter] = useState();
  const [awayFighter, setAwayFighter] = useState();
  const [competition, setCompetition] = useState();
  const [season, setSeason] = useState();
  const [venue, setVenue] = useState();
  const [title, setTitle] = useState();
  const [numberOfRounds, setNumberOfRounds] = useState();
  const [roundMinutes, setRoundMinutes] = useState();
  useEffect(() => {
    if (edit && fixture) {
      setCompetition(fixture.competition);
      setSeason(fixture.season);
      setDate(moment(fixture.date));
      setTime(moment(fixture.time, "HH:mm"));
      setHomeFighter(fixture.home_fighter);
      setAwayFighter(fixture.away_fighter);
      setVenue(fixture.stadium);
      setTitle(fixture.title);
      setNumberOfRounds(fixture.numberOfRounds);
      setRoundMinutes(fixture.roundMinutes);
    }
  }, [edit, fixture]);
  return (
    <Modal
      show={show}
      onCancel={() => {
        onCancel();
      }}
    >
      {show && (
        <Panel style={{ minWidth: "50vw", minHeight: "500px" }}>
          <PanelTitle title={edit ? "Edit Fight" : "Create Fight"}></PanelTitle>
          <PanelContent style={{ width: "100%", flex: "1" }}>
            <Progress
              stages={["Competition", "Kick-Off", "Fighters", "Stadium"]}
              onSave={() => {
                if (edit) {
                  editFixture({
                    fixture: {
                      competition: season.competition._id,
                      season: season._id,
                      home_fighter: homeFighter._id,
                      away_fighter: awayFighter._id,
                      date: moment(date).format("YYYY-MM-DD") + "Z",
                      time: time.format("HH:mm"),
                      description:
                        homeFighter.first_name +
                        " " +
                        homeFighter.last_name +
                        " v " +
                        (awayFighter.first_name + " " + awayFighter.last_name),
                      stadium: venue._id,
                      title,
                      number_of_rounds: parseInt(numberOfRounds),
                      round_minutes: parseInt(roundMinutes),
                    },
                  });
                } else {
                  createFixture({
                    fixture: {
                      competition: season.competition._id,
                      season: season._id,
                      home_fighter: homeFighter._id,
                      away_fighter: awayFighter._id,
                      date: moment(date).format("YYYY-MM-DD") + "Z",
                      time: time.format("HH:mm"),
                      description:
                        homeFighter.first_name +
                        " " +
                        homeFighter.last_name +
                        " v " +
                        (awayFighter.first_name + " " + awayFighter.last_name),
                      stadium: venue._id,
                      title,
                      number_of_rounds: parseInt(numberOfRounds),
                      round_minutes: parseInt(roundMinutes),
                    },
                  }).then(() => {
                    onSaved();
                  });
                }
              }}
            >
              <StageContent>
                <CompetitionSelect
                  competition={competition}
                  season={season}
                  onChange={(competition) => {
                    setCompetition(competition);
                  }}
                  onChangeSeason={(season) => {
                    setSeason(season);
                  }}
                ></CompetitionSelect>
              </StageContent>
              <StageContent>
                <KickOff
                  date={date}
                  time={time}
                  onChangeDate={(date) => {
                    setDate(date);
                  }}
                  onChangeTime={(time) => {
                    setTime(time);
                  }}
                ></KickOff>
              </StageContent>
              <StageContent>
                <TeamSelect
                  season={season}
                  homeFighter={homeFighter}
                  awayFighter={awayFighter}
                  onChangeHomeFighter={setHomeFighter}
                  onChangeAwayFighter={setAwayFighter}
                  numberOfRounds={numberOfRounds}
                  setNumberOfRounds={setNumberOfRounds}
                  roundMinutes={roundMinutes}
                  setRoundMinutes={setRoundMinutes}
                />
              </StageContent>
              <StageContent>
                <VenueSelect stadium={venue} onChange={setVenue} />
              </StageContent>
            </Progress>
          </PanelContent>
        </Panel>
      )}
    </Modal>
  );
}
